import { ZodError } from 'zod';

type LoggerFunction = ((message: string) => void) | undefined;
let logSchemaValidationIssue: LoggerFunction = undefined;

export function setSchemaValidationIssueLogger(loggerFunction: LoggerFunction): void {
	logSchemaValidationIssue = loggerFunction;
}

export function catchAndLog<T>(
	schemaName: string,
	value: T,
	skipIf: ((error: ZodError) => boolean) | undefined = undefined
): (ctx: { error: ZodError }) => T {
	return ctx => {
		if (!skipIf?.(ctx.error)) {
			for (const issue of ctx.error.issues) {
				logSchemaValidationIssue?.(
					`Non-fatal '${schemaName}' validation issue: '${issue.path.join('.')}' ${issue.message}`
				);
			}
		}

		return value;
	};
}
